import { useQuery } from 'react-query';
import { queryAvailableCompanies } from './useAvailableCompanies.query';
import {
  UseAvailableCompaniesOptions,
  UseAvailableCompaniesResponse,
} from './useAvailableCompanies.types';
import { InitConsultationRequestData } from '../../../types/models/consultations/init.types';

export const AVAILABLE_COMPANIES_QUERY_KEY = 'AVAILABLE_COMPANIES';

export const useAvailableCompanies = (
  data: InitConsultationRequestData,
  options?: UseAvailableCompaniesOptions
) => {
  return useQuery<UseAvailableCompaniesResponse, Error>(
    AVAILABLE_COMPANIES_QUERY_KEY,
    () => queryAvailableCompanies(data),
    options
  );
};
